import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import store from '../../redux/store';
import { useSelector } from 'react-redux';
import LottieAnimation2 from './LottieAnimation2';

const PreLoader = () => {

    const [isActive, setIsActive] = useState<number>(0)
    const preLoader = useSelector((state: any) => state.systemSlice.isShowPreloaderCount);
    useEffect(() => {
        let timeout: any
        preLoader === 0 ?
            (timeout = setTimeout(() => {
                setIsActive(preLoader)
            }, 500))
            :
            setIsActive(preLoader)

        return () => { clearTimeout(timeout) }
    }, [preLoader])
    const isLottiePreloader = useSelector((state: any) => state.systemSlice.isLottiePreloader);

    return (
        <>
            {isActive > 0 &&
                <div
                    className='absolute top-0 left-0 w-[100%] h-[100vh] border backdrop-blur-xl flex flex-row justify-center items-center z-[9999999999]' >
                    <div role="status">
                        {isLottiePreloader ?
                            <div className='w-[400px] flex flex-col items-center'>
                                <div >
                                    <LottieAnimation2 />
                                </div>
                                <div className='text-[#7059EF] mt-[-20px] text-[24px] font-bold'>
                                    {isLottiePreloader?.animationText || "UYGULAMANIZ HAZIRLANIYOR..."}
                                </div>

                            </div>
                            :
                            <img src='https://mobligo-bucket.s3.eu-central-1.amazonaws.com/webPreLoader.gif' width={120} alt='preLoader' />
                        }
                    </div>
                </div>
            }
        </>
    );
};

export default PreLoader;


